<template>
  <div>
   <el-dialog title="异常记录"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="recordMark"
    width="60%"
    center>
    <span>
    <div>
      <span>运单号:{{messageData.wayNo}}</span>
      <span style="margin-left:20px">司机:{{messageData.dirverName}}</span>
      <span style="margin-left:20px">司机电话:{{messageData.dirverMobile}}</span>
      <span style="margin-left:20px">车牌号:{{messageData.vhcNo}}</span>
    </div>
    <div style="margin-top:10px">
      <el-table :data="tableData" ref="detailTable" bordersize="mini" class="table" height="300"  style="width: 100%" center border >
        <el-table-column width="120" label="操作">
          <template slot-scope="scope">
              <div>
              <el-button type="text" size="mini" @click="lookImage(scope.row)">查看图片</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column property="reportType" width="" label="异常类型"></el-table-column>
        <el-table-column property="remark" label="异常信息" width="220" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="reportingLocation" width="220" label="上报位置"  :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="reportTime" width="200"  label="上报时间"></el-table-column>
      </el-table>
    </div>
    </span>
    <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog"  size='mini'>取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="查看图片" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="50%" center>
      <div v-if="imgData.length == 0" class="noImg">暂无图片</div>
      <div class="img_box" v-for="(item,index) in imgList" :key="index">
        <el-image
          :src="item"
          :preview-src-list="getSrcList(index)"
          class="tupian"></el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getExceptionReportingList, sWayExsReportingPicture } from '@/api/soc-stock'
export default {
  data () {
    return {
      tableData: [],
      messageData: {
        wayNo: '',
        dirverName: '',
        dirverMobile: '',
        vhcNo: ''
      },
      addMarkLookBox: false,
      imgData: [],
      imgList: []
    }
  },
  props: {
    recordMark: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object
    }
  },
  mounted () {
    this.messageData = this.rowData
    this.getExceptionReportingList()
  },
  methods: {
    // 列表查询
    getExceptionReportingList () {
      getExceptionReportingList({
        wayId: this.messageData.id // 运单Id
      }).then(res => {
        this.tableData = res
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    lookImage (row) {
      this.addMarkLookBox = true
      sWayExsReportingPicture({
        wayId: row.wayId,
        reportId: row.id
      }).then(res => {
        this.imgList = []
        this.imgData = res.reportImgs
        this.imgList = res.reportImgs.map(item => item.fileUrlOSS)
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    closeDialog () {
      this.$emit('update:recordMark', false)
    },
    // 点击图片放大
    getSrcList (index) {
      return this.imgList.slice(index).concat(this.imgList.slice(0, index))
    }
  }
}
</script>

<style scoped lang='less'>
.img_box {
  width: 200px;
  height: 200px;
  display: inline-block;
  margin-right: 20px;
  // border: 1px dashed #ccc;
  padding: 5px;
  .tupian {
    width:100%;
    height: 100%;
    // max-width:100%;
    // object-fit:none;/*保留原有元素内容的长度和宽度*/
  }
}
</style>
